import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=20e923c3&scoped=true&"
import script from "./CardForm.vue?vue&type=script&lang=js&"
export * from "./CardForm.vue?vue&type=script&lang=js&"
import style0 from "./CardForm.vue?vue&type=style&index=0&id=20e923c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e923c3",
  null
  
)

export default component.exports